import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaMapMarkedAlt, 
  FaUserFriends, 
  FaMobileAlt, 
  FaHeart,
  FaLightbulb,
  FaCompass,
  FaCamera,
  FaRocket
} from 'react-icons/fa';
import UnifiedStarBackground from '../components/UnifiedStarBackground';
import '../styles/About.css';

const About: React.FC = () => {
  return (
    <div className="about">
      <UnifiedStarBackground variant="primary" />
      
      {/* Hero Section */}
      <div className="about-hero">
        <div className="container">
          <h1>About TripGo!!</h1>
          <p className="tagline">Your ultimate guide to exploring the best tourist destinations in India</p>
        </div>
      </div>

      {/* Our Story Section */}
      <div className="container section">
        <div className="story-section">
          <div className="section-header">
            <FaLightbulb className="section-icon" />
            <h2>Our Story</h2>
          </div>
          <p className="story-text">
            At TripGo!!, we aim to simplify your travel experience by showcasing the most beautiful 
            and iconic tourist places in every Indian city. Whether you love heritage sites, beaches, 
            or hill stations, we help you plan your journey effortlessly.
          </p>
          <div className="mission-points">
            <Link to="/mission/travel-planning" className="mission-point">
              <FaCompass className="point-icon" />
              <p>Making travel planning easier and more intuitive</p>
            </Link>
            <Link to="/mission/showcasing-destinations" className="mission-point">
              <FaCamera className="point-icon" />
              <p>Showcasing India's most beautiful destinations</p>
            </Link>
            <Link to="/mission/empowering-travelers" className="mission-point">
              <FaRocket className="point-icon" />
              <p>Empowering travelers with the right information</p>
            </Link>
          </div>
        </div>

        {/* Features Section */}
        <div className="features-section">
          <div className="section-header">
            <FaHeart className="section-icon" />
            <h2>Why Choose Us?</h2>
          </div>
          <div className="features-grid">
            <Link to="/features/city-spots" className="feature-card">
              <FaMapMarkedAlt className="feature-icon" />
              <h3>City-wise Tourist Spots</h3>
              <p>Explore curated destinations with high-quality images and detailed information</p>
              <span className="learn-more">Learn More →</span>
            </Link>
            <Link to="/features/easy-navigation" className="feature-card">
              <FaUserFriends className="feature-icon" />
              <h3>Easy Navigation</h3>
              <p>User-friendly design making your travel planning seamless and enjoyable</p>
              <span className="learn-more">Learn More →</span>
            </Link>
            <Link to="/features/personalized" className="feature-card">
              <FaHeart className="feature-icon" />
              <h3>Personalized Experience</h3>
              <p>Save your favorite destinations and create custom travel plans</p>
              <span className="learn-more">Learn More →</span>
            </Link>
            <Link to="/features/mobile-friendly" className="feature-card">
              <FaMobileAlt className="feature-icon" />
              <h3>Mobile Friendly</h3>
              <p>Access TripGo!! on any device with our responsive design</p>
              <span className="learn-more">Learn More →</span>
            </Link>
          </div>
        </div>

        {/* Stats Section */}
        <div className="stats-section">
          <div className="stat-card">
            <h3>50+</h3>
            <p>Cities Covered</p>
          </div>
          <div className="stat-card">
            <h3>1000+</h3>
            <p>Tourist Spots</p>
          </div>
          <div className="stat-card">
            <h3>24/7</h3>
            <p>Support</p>
          </div>
          <div className="stat-card">
            <h3>10K+</h3>
            <p>Happy Travelers</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;